import { render } from "./indexInvoice.vue?vue&type=template&id=6b0aef4a"
import script from "./indexInvoice.vue?vue&type=script&lang=js"
export * from "./indexInvoice.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__